import { Component, Input } from '@angular/core';
import { BrIconComponent } from '../../../shared/ui/icon/icon.component';
import { MapObjectReference } from '../../core/map-object';
import { MapObjectPopover } from '../../core/map-object-popover';
import { ShowOnMapDirective } from './show-on-map.directive';

/**
 * A map action, independent of list selection, record details and routing.
 *
 * The action itself belongs to ShowOnMapDirective, which a row's name wears
 * too. What is left here is the button that offers it: an icon, a label, and
 * the disabled state that says a record has nowhere to be shown.
 */
@Component({
  selector: 'app-map-pin',
  standalone: true,
  imports: [BrIconComponent, ShowOnMapDirective],
  template: `
    <button type="button" class="br-btn br-btn--ghost br-icon-btn br-interactive" #pin="showOnMap"
            [appShowOnMap]="object" [latitude]="latitude" [longitude]="longitude" [popup]="popup"
            [disabled]="!pin.located" [title]="pin.located ? 'Show on map' : 'Location unavailable'"
            [attr.aria-label]="pin.located ? 'Show on map' : 'Location unavailable'">
      <br-icon>location_on</br-icon>
    </button>
  `,
})
export class MapPinComponent {
  @Input() latitude?: number | null;
  @Input() longitude?: number | null;
  @Input() object?: MapObjectReference;
  @Input() popup?: MapObjectPopover;
}
